{
    "AlarmonnewabandonedcallLabel": "Alarme em nova chamada abandonada:",
    "NAME": "AbandonedCallAlarm",
    "AbandonedCallAlarm_SectionHeader": "Alarme de chamada abandonada",
    "AbandonedCallAlarm_SectionPara": "pode ativar um alarme quando ocorrerem novas chamadas abandonadas."
}